import { render, staticRenderFns } from "./EditOffers.vue?vue&type=template&id=6188dbbd&scoped=true&"
import script from "./EditOffers.vue?vue&type=script&lang=js&"
export * from "./EditOffers.vue?vue&type=script&lang=js&"
import style0 from "./EditOffers.vue?vue&type=style&index=0&id=6188dbbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188dbbd",
  null
  
)

export default component.exports